
<template>
  <v-card flat class="" @click="$emit('click')" v-ripple style="border-radius: 28px; border: solid #f6f6f6 1px; cursor: pointer;" >
    <v-card-text class="pa-2" :style="{borderRadius: '28px', borderLeft: `solid ${marker_color} 30px`}">
      <v-row class="pa-3" align='center'>
        <!-- <v-icon large class="mr-2">mdi-circle</v-icon> -->
        <slot name="icon">
          <v-icon class="mr-2" >mdi-check-circle-outline</v-icon>
        </slot>
        <slot name="text">
          <span style="max-width: 250px;" class="black--text title text-truncate"> Lorem ipsum dolor sit, amet consectetur adipisicing elit.</span>
        </slot>
        <v-spacer v-if="with_spacer"></v-spacer>
        <slot name="last">
          <v-chip small>
            <v-avatar left>
              <v-icon>mdi-calendar</v-icon>
            </v-avatar>
            12/12/12 - 12/12/12
          </v-chip>
        </slot>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'BaseInfoCardMarker',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    marker_color: {
      type: String,
      default: '7051F0'
    },
    with_spacer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>